module.exports = __webpack_public_path__ + "img/c2m_dig_market.e05bba10.png";